const serverType = {
  OnTheBeach: 'OnTheBeach',
  Wetterheld: 'Wetterheld',
  BlueCross: 'BlueCross',
  Baloise: 'Baloise',
};

export default serverType;
